import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'existIn'
})
export class ExistInPipe implements PipeTransform {

  transform<T>(value: T, array: T[]): boolean {
    return array.includes(value);
  }

}
